// Experiment Naming Convention: snake_case
// Example: {
//            name: 'experiment_name',
//            variants: ['variant_name', 'other_variant_name'],
//          }

export const experiments = [];
